import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const machineRoutes: RouteRecordRaw[] = [
  {
    path: '/machines',
    name: RouteNames.Machines,
    component: () => import('@/views/machine/ListMachines.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/machines/deprecated',
    name: RouteNames.DeprecatedMachines,
    component: () => import('@/views/deprecated/AllMachinesView.vue'),
  },
  {
    path: '/runtime-errors',
    name: RouteNames.ErrorLogs,
    component: () => import('@/views/runtime-errors/ListRuntimeErrors.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/runtime-errors/deprecated',
    name: RouteNames.DeprecatedErrorLogs,
    component: () => import('@/views/deprecated/ErrorLogsView.vue'),
  },
  {
    path: '/metrics',
    name: RouteNames.Metrics,
    component: () => import('@/views/metrics/MachineMetrics.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/metrics/deprecated',
    name: RouteNames.DeprecatedMetrics,
    component: () => import('@/views/deprecated/MetricsView.vue'),
  },
];

export default machineRoutes;
